module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-photo-9-cbfe74b87bcc2695136bbbb900551e8e.webp";